import i18n from 'modules/core/lib/i18n'

import Item from 'modules/contracts/components/ContractDetails/LegalAndLabour/Item'

interface Props {
  echelon?: string
}

const Echelon = ({ echelon }: Props) => {
  return (
    <Item
      title={i18n.t('contract_versions.legal_and_labour.france.echelon')}
      description={echelon}
    />
  )
}

export default Echelon
